import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gallery-modal__sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "gallery-modal__sidebar-heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "gallery-modal__sidebar-sub-title" }, " Tags ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "gallery-modal__sidebar-block gallery-modal__sidebar-block--separator" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "gallery-modal__comments-heading" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "gallery-modal__sidebar-sub-title" }, " Add tags ", -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "gallery-modal__sidebar-block gallery-modal__sidebar-block--separator"
}
const _hoisted_8 = { class: "form__set form__set--sidebar mb-16" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label"
}, " Enter a tag ", -1 /* HOISTED */)
const _hoisted_10 = ["disabled", "onKeyup"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "gallery-modal__sidebar-block" }
const _hoisted_14 = { class: "search-bar search-bar--sidebar mb-16" }
const _hoisted_15 = {
  ref: "tags_container",
  class: "tags-container tags-container--sidebar"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "mb-32"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["gallery-modal__sidebar-content", { 'gallery-modal__sidebar-content--loading': $setup.loading }])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_TransitionGroup, {
          name: "grid",
          tag: "ul",
          class: "tags tags--inverted"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_option.database_tags, (tag) => {
              return (_openBlock(), _createElementBlock("li", {
                key: tag.id,
                class: "tags__tag tags__tag--selected"
              }, [
                _createTextVNode(_toDisplayString(tag.title) + " ", 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "tags__remove-tag",
                  onClick: $event => ($setup.removeTag( tag.id ))
                }, null, 8 /* PROPS */, _hoisted_4)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (!$setup.show_create_tags)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = $event => ($setup.show_create_tags = !$setup.show_create_tags)),
              class: "gallery-modal__create-tag-btn"
            }, " Create tag "))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.show_create_tags)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                id: "new_tag",
                ref: "new_tag_input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.new_tag) = $event)),
                class: "form__input form__input--lowercase",
                type: "text",
                name: "new_tag",
                disabled: $setup.loading,
                onKeyup: _withKeys($setup.submitNewTag, ["enter"])
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                [_vModelText, $setup.new_tag]
              ])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["button button--invert", { 'button--loading': $setup.loading }]),
              disabled: !$setup.new_tag || $setup.loading,
              onClick: $setup.submitNewTag
            }, " Create tag ", 10 /* CLASS, PROPS */, _hoisted_11),
            ($setup.error_message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($setup.error_message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "search-bar__field a4-12",
            onClick: $setup.focusTagSearch
          }, [
            _createElementVNode("input", {
              ref: "tag_search_input",
              class: "search__input search__input--fw-400",
              type: "text",
              placeholder: "Search for a tag",
              onInput: $setup.handleTagSearchInputChange
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          ($setup.filtered_common_tags.length)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 0,
                name: "grid",
                tag: "ul",
                class: _normalizeClass(["tags tags--search tags--overflow-scroll", {
							'tags--overflowing': $setup.tags_overflowing
						}])
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filtered_common_tags, (tag) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tag.id,
                      class: "tags__tag tags__tag--selectable",
                      onClick: $event => ($setup.addTag( tag.title ))
                    }, _toDisplayString(tag.title), 9 /* TEXT, PROPS */, _hoisted_16))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_17, " No common tags found. "))
        ], 512 /* NEED_PATCH */)
      ])
    ], 2 /* CLASS */)
  ]))
}